// src/services/presence/useListenStatus.ts
import { useEffect, useState } from "react";
import { ref, onValue, off } from "firebase/database";
import { rtdb } from "../config/firebase";

export const useListenStatus = () => {
  const [statuses, setStatuses] = useState({});

  useEffect(() => {
    let statusRef;

    try {
      if (!rtdb) throw new Error("Realtime Database instance (rtdb) is undefined");

      statusRef = ref(rtdb, "/status");

      const handleValue = (snapshot) => {
        try {
          const data = snapshot.val() || {};
          setStatuses(data);
        } catch (err) {
          console.error("Error reading snapshot data:", err);
        }
      };

      onValue(statusRef, handleValue);

    } catch (err) {
      console.error("Error setting up listener for /status:", err);
    }

    // Cleanup listener
    return () => {
      try {
        if (statusRef) off(statusRef, "value");
      } catch (err) {
        console.error("Error cleaning up /status listener:", err);
      }
    };
  }, []);

  return statuses;
};


// // src/services/presence/useListenStatus.ts
// import { useEffect, useState } from "react";
// import { ref, onValue, off } from "firebase/database";
// import { rtdb } from "../config/firebase";



// export const useListenStatus = () => {
//   const [statuses, setStatuses] = useState({});
  

//   useEffect(() => {
//     const statusRef = ref(rtdb, "/status");

//     const handleValue = (snapshot) => {
//       const data = snapshot.val() || {};
//       setStatuses(data);
//     };

//     onValue(statusRef, handleValue);

//     return () => {
//       off(statusRef, "value", handleValue);
//     };
//   }, []);

//   return statuses;
// };
